export type TimeRange = { start: number; end: number };
export function rangesForDay(day: boolean[]): TimeRange[] {
  const ranges: TimeRange[] = [];
  for (let slot = 0; slot < 48; slot++) {
    if (!day[slot]) continue;
    const start = slot;
    while (slot < 48 && day[slot]) slot++;
    ranges.push({ start, end: slot });
  }
  return ranges;
}
export function applyRange(week: boolean[][], days: number[], range: TimeRange, enabled: boolean): boolean[][] {
  return week.map((day, d) => day.map((value, slot) => days.includes(d) && slot >= range.start && slot < range.end ? enabled : value));
}
export function clockLabel(slot: number): string {
  const hour = Math.floor(slot / 2) % 24;
  return `${hour % 12 || 12}:${slot % 2 ? "30" : "00"} ${hour < 12 ? "AM" : "PM"}`;
}
